import React from "react";
import { Select } from "antd";
import { useQuery } from "react-query";

import { LookUpApiService } from "../../../ApiServices";
import { API_STORAGE_KEY } from "../../../constants/constant";
import notificationService from "../../../util/notification.service";

const getChildInterestTag = async () => {
    const { ok, data, response } = await LookUpApiService.childInterest();
    if (ok) {
        return data;
    } else {
        notificationService.error(response.message);
        throw new Error(response.message);
    }
};

const ChildInterestLookup = (props) => {
    const { data: childTag = [], isLoading } = useQuery(API_STORAGE_KEY.CHILD_INTEREST_LOOKUP, getChildInterestTag);

    return (
        <>
            <Select
                mode="multiple"
                disabled={isLoading}
                loading={isLoading}
                showSearch
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                filterOption={(input, option) => {
                    return option.props.children.toLowerCase().includes(input.toLowerCase());
                }}
                {...props}
            >
                {childTag?.map((data, index) => {
                    return (
                        <Select.Option key={data?.id} value={data.id}>
                            {data.name}
                        </Select.Option>
                    );
                })}
            </Select>
        </>
    );
};
export default ChildInterestLookup;
